export default __webpack_public_path__ + "src/images/content/presentation-1-ea45820d9b96f16696358673a623f330.png";